export default "__VITE_ASSET__S8i0tBum__"